// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"138":"d852e7d3","423":"19730f4f"}[chunkId] + ".chunk.js";
};